import { render, staticRenderFns } from "./DriverDashboard.vue?vue&type=template&id=b1c78460&scoped=true"
import script from "./DriverDashboard.vue?vue&type=script&lang=js"
export * from "./DriverDashboard.vue?vue&type=script&lang=js"
import style0 from "./DriverDashboard.vue?vue&type=style&index=0&id=b1c78460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c78460",
  null
  
)

export default component.exports